var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data),function(block,index){return _c(_vm.setBlock(block.acf_fc_layout),{key:index,tag:"component",attrs:{"data":block}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }